import type { IconData } from '@stacksjs/iconify-core'

export const chevronDoubleDown: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m252.482 345.034l-109.02-109.021L64 315.475l109.087 109.088l-.041.041l68.082 68.082l11.354 11.273l.041.041l68.15-68.148l11.206-11.289l109.087-109.088l-79.466-79.462Zm45.523 68.149l-11.17 11.252l-34.353 34.351l-.039-.038l-34.276-34.277l.041-.042l-108.954-108.954l34.208-34.207l109.02 109.021L361.5 281.268l34.208 34.207Z\"/><path fill=\"currentColor\" d=\"m173.046 203.4l68.082 68.082l11.354 11.272l.041.042l68.15-68.149l11.206-11.289L440.966 94.267L361.5 14.8L252.482 123.825L143.462 14.8L64 94.267l109.087 109.087ZM109.254 94.267l34.208-34.208l109.02 109.021L361.5 60.059l34.208 34.208l-97.707 97.707l-11.182 11.264l-34.341 34.34l-.039-.039l-34.276-34.277l.041-.041Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default chevronDoubleDown
